import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ErrorDatabaseQueryParams, ErrorDatabaseResponse } from './service-documents.model';

@Injectable({ providedIn: 'root' })
export class ServiceDocumentMockApi {
  constructor() {}

  listErrorsDatabase(_params: ErrorDatabaseQueryParams): Observable<ErrorDatabaseResponse> {
    return of({
      countryCode: 'DE',
      languageCode: 'de',
      availableLanguages: [],
      faultCodes: [],
      _links: [],
    });
  }
}
